import * as PouchDB from 'pouchdb'

export class AppStorage {

    private databaseName: string = 'foorize-vue-v1.0'

    private db: PouchDB.Database | undefined

    constructor() {
        this.initDB()
    }

    private initDB(): void {
        this.db = new PouchDB.default(this.databaseName)
    }

    public async get(key: string): Promise<any> {
        try {

            if (!this.db)
                return

            const doc = await this.db.get(key) as any

            return doc['content']

        } catch (e) {
            // console.log(`pouchdb error: ${e.message}`)
        }
    }

    public async set(key: string, payload: string): Promise<any> {
        try {

            if (!this.db)
                return

            let doc: any

            try {
                doc = await this.db.get(key)
            } catch (e) { }

            if (doc)
                await this.db.put({
                    _id: key,
                    _rev: doc._rev,
                    content: payload
                })
            else
                await this.db.put({
                    _id: key,
                    content: payload
                })

        } catch (e) {
            // console.log(`pouchdb error: ${e.message}`)
        }
    }
}
